import { DataRequestStateEnum } from "@/core/types/dataRequestsTypes";

export default function hasValidData<T>(data: T | null, dataRequestState: DataRequestStateEnum): data is T {
  return Array.isArray(data)
    ? data.length !== 0 && dataRequestState === DataRequestStateEnum.FULFILLED
    : data !== null && dataRequestState === DataRequestStateEnum.FULFILLED;
}
